<template>
  <admin-page-frame>
    <school-list-toolbar @search="loadList" @reset="handleReset">
      <template #actions><el-button class="filter-item" type="primary" size="mini" icon="el-icon-plus" @click="openForm()">新增</el-button></template>
      <template #filters>
        <el-input v-model="query.keyword" clearable size="small" placeholder="姓名/手机号" class="filter-item" style="width: 200px; margin-right: 10px;" @keyup.enter.native="loadList" />
        <el-select v-model="query.status" clearable size="small" placeholder="状态" class="filter-item" style="width: 120px; margin-right: 10px;">
          <el-option label="在职" :value="1" /><el-option label="停用" :value="0" />
        </el-select>
      </template>
    </school-list-toolbar>
    <el-table v-loading="loading" :data="list" :border="false" size="small" style="width: 100%;">
      <el-table-column label="图片" width="72" align="center">
        <template slot-scope="{ row }">
          <img v-if="firstImage(row)" :src="toFullUrl(firstImage(row))" style="width: 44px; height: 44px; object-fit: cover; border-radius: 4px;">
          <span v-else style="color:#c0c4cc;">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="teacherName" label="姓名" min-width="100" show-overflow-tooltip />
      <el-table-column prop="mobile" label="手机" min-width="120" />
      <el-table-column prop="intro" label="简介" min-width="180" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="80" align="center"><template slot-scope="{ row }"><el-tag :type="row.status === 1 ? 'success' : 'info'" size="mini">{{ row.status === 1 ? '在职' : '停用' }}</el-tag></template></el-table-column>
      <el-table-column label="操作" min-width="80" width="80" align="center" fixed="right" class-name="admin-pc-table-actions-col">
        <template slot-scope="{ row }"><div class="admin-pc-table-actions"><el-button type="text" size="mini" @click="openForm(row)">编辑</el-button></div></template>
      </el-table-column>
    </el-table>
    <school-list-pagination :total="total" :page="query.page" :size="query.size" @page-change="onPageChange" @size-change="onSizeChange" />
    <el-dialog :title="form.id ? '编辑教师' : '新增教师'" :visible.sync="formVisible" width="560px" :close-on-click-modal="false" @closed="resetForm">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="90px" size="small" class="admin-pc-dialog-form">
        <el-form-item label="姓名" prop="teacherName"><el-input v-model="form.teacherName" maxlength="64" /></el-form-item>
        <el-form-item label="手机"><el-input v-model="form.mobile" maxlength="20" /></el-form-item>
        <el-form-item label="图片">
          <admin-multi-image-upload v-model="form.imageUrls" :limit="9" />
        </el-form-item>
        <el-form-item label="简介"><el-input v-model="form.intro" type="textarea" :rows="3" maxlength="512" /></el-form-item>
        <el-form-item label="状态"><el-radio-group v-model="form.status"><el-radio :label="1">在职</el-radio><el-radio :label="0">停用</el-radio></el-radio-group></el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer"><el-button size="small" @click="formVisible = false">取消</el-button><el-button type="primary" size="small" :loading="saving" @click="submitForm">保存</el-button></div>
    </el-dialog>
  </admin-page-frame>
</template>
<script>
import AdminPageFrame from './components/AdminPageFrame.vue'
import SchoolListToolbar from './components/SchoolListToolbar.vue'
import SchoolListPagination from './components/SchoolListPagination.vue'
import AdminMultiImageUpload from '../../admin/components/AdminMultiImageUpload.vue'
import schoolListPageMixin from './mixins/school-list-page'
import { fetchSchoolTeachers, saveSchoolTeacher, updateSchoolTeacher } from '@/api/h5-admin-schools'
import { resolveUploadUrl } from '@/utils/uploadBase'
import './schools-admin.less'

const DEFAULT_QUERY = { keyword: '', status: null, page: 0, size: 20 }

function emptyForm() {
  return { id: null, teacherName: '', mobile: '', imageUrls: [], intro: '', status: 1 }
}

export default {
  name: 'SchoolsTeacher',
  components: { AdminPageFrame, SchoolListToolbar, SchoolListPagination, AdminMultiImageUpload },
  mixins: [schoolListPageMixin],
  data() {
    return {
      loading: false, saving: false, list: [], total: 0, query: { ...DEFAULT_QUERY }, formVisible: false,
      form: emptyForm(),
      formRules: { teacherName: [{ required: true, message: '请输入教师姓名', trigger: 'blur' }] }
    }
  },
  created() { this.loadList() },
  methods: {
    handleReset() { this.resetListQuery(DEFAULT_QUERY) },
    firstImage(row) { return (row.imageUrls && row.imageUrls[0]) || row.avatarUrl || '' },
    toFullUrl(raw) {
      return resolveUploadUrl(raw)
    },
    applyClientFilters(rows) { let list = rows || []; if (this.query.status != null && this.query.status !== '') list = list.filter(r => r.status === this.query.status); return list },
    loadList() {
      this.loading = true
      const hasClientFilter = this.query.status != null && this.query.status !== ''
      const params = { keyword: this.query.keyword || undefined, page: hasClientFilter ? 0 : this.query.page, size: hasClientFilter ? 500 : this.query.size }
      fetchSchoolTeachers(params).then(res => {
        let list = (res && res.content) || []; list = this.applyClientFilters(list)
        if (hasClientFilter) { this.total = list.length; const start = this.query.page * this.query.size; list = list.slice(start, start + this.query.size) } else { this.total = (res && res.totalElements) || 0 }
        this.list = list
      }).finally(() => { this.loading = false })
    },
    openForm(row) {
      if (row) {
        this.form = {
          id: row.id, teacherName: row.teacherName, mobile: row.mobile || '',
          imageUrls: Array.isArray(row.imageUrls) ? [...row.imageUrls] : [],
          intro: row.intro || '', status: row.status != null ? row.status : 1
        }
      } else { this.resetForm() }
      this.formVisible = true
    },
    resetForm() { this.form = emptyForm(); this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate()) },
    submitForm() { this.$refs.formRef.validate(valid => { if (!valid) return; this.saving = true; const req = this.form.id ? updateSchoolTeacher(this.form.id, this.form) : saveSchoolTeacher(this.form); req.then(() => { this.$message.success('保存成功'); this.formVisible = false; this.loadList() }).finally(() => { this.saving = false }) }) }
  }
}
</script>
